import React from "react";
import Container from "react-bootstrap/Container";
import "./Privacy.css";

function Privacy() {
  return (
    <div className="privacy-page">
      <Container className="privacy-container">
        <h1 className="privacy-title">Privacy Policy</h1>

        <div className="privacy-card">
          <p>
            <strong>Developer Name:</strong> Ixmeh_apps
          </p>
          <p>
            <strong>Legal Owner:</strong> Mehwish Riaz
          </p>

          <p>
            <strong>Address:</strong>
            <br />
            36 Kennet Road
            <br />
            Abingdon, OX14 3ST
            <br />
            United Kingdom
          </p>

          <p>
            <strong>Contact Email:</strong> ixmehapps@gmail.com
          </p>
        </div>

        <p className="privacy-text">
          This Privacy Policy explains how the mobile applications
          <strong> “Clash King 3D”</strong> and <strong>“Delivery Boy”</strong>
          (the “Apps”), published by <strong>Ixmeh_apps</strong>, collect, use,
          and protect your personal data.
        </p>

        <h2>1. Information We Collect</h2>
        <p className="privacy-text">
          We may collect device information, identifiers, IP address
          (approximate), gameplay activity, session duration, and in-app
          purchase data.
        </p>

        <h2>2. Information from Third-Party Services</h2>
        <p className="privacy-text">
          Our Apps use third-party services such as Google Play Services,
          advertising networks, and analytics providers.
        </p>

        <h2>3. How We Use Your Information</h2>
        <p className="privacy-text">
          We use collected data to improve gameplay, display ads, analyze usage,
          and ensure technical stability.
        </p>

        <h2>4. Service Providers</h2>
        <ul className="privacy-list">
          {[
            ["Admob", "https://policies.google.com/privacy"],
            ["Unity", "https://unity.com/legal/privacy-policy"],
            ["Firebase", "https://firebase.google.com/support/privacy"],
            [
              "Game Analytics",
              "https://www.gameanalytics.com/trust/privacy-notice",
            ],
            ["Applovin", "https://www.applovin.com/en"],
            [
              "IronSource",
              "https://developers.is.com/ironsource-mobile/privacypolicy/",
            ],
            ["Mintegral", "https://www.mintegral.com/en/privacy"],
            [
              "Digital Turbine",
              "https://www.digitalturbine.com/legal/privacy-policy",
            ],
            ["Vungle", "https://liftoff.ai/privacy-policy/"],
            ["InMobi", "https://advertising.inmobi.com/privacy-policy"],
          ].map(([name, link]) => (
            <li key={name}>
              <a href={link} target="_blank" rel="noopener noreferrer">
                {name}
              </a>
            </li>
          ))}
        </ul>

        <h2>5. Sharing of Information</h2>
        <p className="privacy-text">
          We do not sell personal data. Information may be shared only for
          analytics, ads, or legal compliance.
        </p>

        <h2>6. Children’s Privacy</h2>
        <p className="privacy-text">
          These Services are not directed to children under 13. We do not
          knowingly collect Personal Data from children under 13. If we become
          aware that a child under 13 has provided us with Personal Data, we
          will delete such information from our files. If you believe that we
          might have any data from or about a child under the age of 13, please
          contact us.
        </p>

        <h2>7. Data Security</h2>
        <p className="privacy-text">
          We take all reasonable precautions necessary to protect your personal
          data from loss, misuse, and interference, unauthorized access,
          disclosure, use, or modification. The security of your data is
          important to us, but remember that no method of transmission over the
          Internet, or method of electronic storage is 100% secure.
        </p>

        <h2>8. Changes to This Policy</h2>
        <p className="privacy-text">Updates will be posted on this page.</p>

        <p className="privacy-updated">
          <strong>Last Updated:</strong> 7 December 2025
        </p>
      </Container>
    </div>
  );
}

export default Privacy;
